/* Mirrors the columns computed in category-nav.tsx (isMd/isLg from
   src/hooks/use-breakpoint.ts: md=768, lg=1024) and Spacing.two/Spacing.three
   from src/constants/theme.ts — keep in sync if those change.

   Grid-based column count instead of a JS-measured `itemWidth` (useState +
   onLayout) avoids the post-mount snap from 5 -> 6 -> 10 columns that
   showed up as a height jump once the page-level layout flash was fixed. */

.section {
  padding: 0 16px;
}

@media (min-width: 1024px) {
  .section {
    padding: 0;
  }
}

.grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
}

@media (min-width: 768px) {
  .grid {
    grid-template-columns: repeat(6, 1fr);
  }
}

@media (min-width: 1024px) {
  .grid {
    grid-template-columns: repeat(10, 1fr);
  }
}
